var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C15.1634 0 8 7.16344 8 16H40C40 7.16344 32.8366 0 24 0Z",
    fill: "#FFFBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.99995 12C2.30812 12 0.861614 13.0503 0.27693 14.5345C-0.0267159 15.3053 0.67152 16 1.49995 16H7.99995C7.99995 13.7909 6.20909 12 3.99995 12Z",
    fill: "#FFFBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 16.0002C40 12.2652 42.5595 9.12803 46.0202 8.247C47.0907 7.97449 48 8.89558 48 10.0001L48 14.0002C48 15.1047 47.1046 16.0002 46 16.0002L40 16.0002Z",
    fill: "#FFFBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40 15.9998C40 19.7348 37.4405 22.872 33.9798 23.753C32.9093 24.0255 32 23.1044 32 21.9999L32 15.9998L40 15.9998Z",
    fill: "#FFFBF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16 15.9998C16 19.7348 13.4405 22.872 9.97976 23.753C8.90933 24.0255 8 23.1044 8 21.9999L8 15.9998L16 15.9998Z",
    fill: "#FFFBF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93ee2bd4908739b6daaf1f8b8def1dba.svg";
export { ForwardRef as ReactComponent };